<template>
  <div class="bottomSettingSub">
    <div class="setBox">
      <ul>
        <li v-for="(item, index) in qualityList" :key="item.id" @click.prevent="selectQuality(index)">
          <div class="setText" :class="{ select : item.id === currQuality }">{{ (item.marks != null && item.marks === 'F' ? ( item.name + ' (무료)' ) : item.name ) }}</div>
        </li>
        <li class="closeLi" @click.prevent="closeQuality">
          <div class="setText close04">취소</div>
          <div class="value"></div>
        </li>
      </ul>
    </div>
    <div @click.prevent="closeQuality" class="dim2"></div>
  </div>
</template>
<script>
import utils from '@/common/util/utils'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
export default {
  name: 'QualitySelect',
  props: {
    qualityList: {
      type: Array
    },
    currQuality: {
      type: String
    }
  },
  data () {
    return {
      savedIndex: 0
    }
  },
  mounted () {
    this.$emit('on-load', this)
  },
  methods: {
    closeQuality () {
      this.$parent.closeSetting()
    },
    selectQuality (index) {
      this.savedIndex = index
      let target = this.qualityList[index].id
      utils.cookies.setItem('userSelectQuality', target, null, URL_COOKIE_DOMAIN, '/')
      if (target === this.currQuality) this.closeQuality()
      else {
        this.$parent.vodObject.clearPurchaseMsg()
        this.$parent.changeQuality(target)
      }
    },
    autoChangeQuality () {
      this.savedIndex++
      this.$parent.changeQuality(this.qualityList[this.savedIndex].id)
    }
  }
}
</script>
<style>
<style scoped>
.bottomSettingSub { position: absolute; top:0px; left:0px;  width: 100%;   height: 100vh;   z-index: 3002;   }
.bottomSettingSub .setBox { position: absolute; bottom:0px; left:0px; z-index: 10000; width: 100%;  }
.bottomSettingSub li  { width: 100%; height: 60px; background: #252525; line-height: 60px; vertical-align:  middle; border-bottom: 1px solid #2f2f2f }
.bottomSettingSub li .setText {font-size: 14px;color: #ffffff;margin: 0 20px 0 20px;float: left;width: inherit;text-indent:32px;height: 60px;line-height: 60px; vertical-align: middle;background-position: 0% 50%; background-size:20px 20px; }
.bottomSettingSub li.closeLi  { background: #1b1b1b; }
.bottomSettingSub .dim2 { background-color: #000; opacity: 0.7;position: absolute; top:0px; left:0px; width: 100%; height: 100vh; z-index: 3}
.bottomSettingSub .close04  { background: url(../../assets/images/ic_player_more_close_w.png) no-repeat;  }
.bottomSettingSub .select { background: url(../../assets/images/ic_player_more_select.png) no-repeat;  }
</style>
